import { render, staticRenderFns } from "./TableConstructor.vue?vue&type=template&id=a896af60&lang=pug"
import script from "./TableConstructor.vue?vue&type=script&lang=js"
export * from "./TableConstructor.vue?vue&type=script&lang=js"
import style0 from "./TableConstructor.vue?vue&type=style&index=0&id=a896af60&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports